export const PORTAL_TITLE = "Capital One Travel Portal";
export const BOOKING_CONFIRMATION_TITLE = "Booking Confirmation";
